<template>
  <div>
    <b-modal
      id="add-lead-modal"
      ref="modal"
      header-class="headerModal"
      centered
      size="xl"
      modal-class="dd"
      :title="$t('Add Lead')"
      hide-footer
      @close="onCancel"
    >
    <div v-if="isSubmitting" class="modal-loader">
  <b-spinner
    variant="primary"
    label="Loading..."
    style="width: 3rem; height: 3rem;"
  />
</div>

      <b-form>
        <section
          class="custom-modal__wrapper"
          style="border-width: 3px"
        >
          <b-tabs
            v-model="tabIndex"
          >
            <b-tab
              :title="$t('PersonalInfo')"
              active
            >
              <template #title>
                <strong style="font-weight: 500; color: black">{{ $t("PersonalInfo") }}</strong>
              </template>
              <div>
                <b-collapse
                  id="collapse-345"
                  visible
                >
                  <div class="hello">
                    <b-form-group :label="$t('Salutation')">
                      <vue-select
                        v-model="form.salutation"
                        :options="salutation"
                        :placeholder="$t('SelectSalutation')"
                        aria-describedby="input-1-live-feedback"
                      />

                    </b-form-group>

                    <b-form-group :label="`${$t('FirstName')}`">
                      <b-form-input
                        id="firstName"
                        v-model="form.firstName"
                        :state="validateState('firstName')"
                        placeholder="e.g. Michael"
                        aria-describedby="input-1-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                        $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                      }}</b-form-invalid-feedback>
                    </b-form-group>
                  </div>

                  <div class="hello">
                    <b-form-group :label="`${$t('LastName')}`">
                      <b-form-input
                        id="lastname"
                        v-model="form.lastname"
                        :state="validateState('lastname')"
                        placeholder="e.g. Smith"
                        aria-describedby="input-1-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                        $t('This_is_a_required_field_and_must_be_at_least_3_letters')
                      }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                      id="input-group-9"
                      :label="`${$t('DateofBirth')}:`"
                      label-for="input-9"
                      style="width:49%"
                    >
                      <date-picker
                        v-model="selectedDate"
                        value-type="format"
                        class="form-control"
                        format="DD-MM-YYYY"
                        type="date"
                        :placeholder="$t('SelectD')"
                        style="width: 100%;"
                        :lang="lang"
                      />
                    </b-form-group>

                  </div>
                  <div class="hello">
                    <b-form-group :label="`${$t('Gender')}`">
                      <vue-select
                        v-model="form.gender"
                        :options="genderOptions"
                        :reduce="(e) => e.value"
                        label="text"
                        :placeholder="$t('SelectGender')"
                        aria-describedby="input-1-live-feedback"
                      />

                    </b-form-group>
                    <b-form-group :label="`${$t('Email')}`">
                      <b-form-input
                        id="email"
                        v-model="form.email"
                        placeholder="e.g. example@digitbusiness.ch"
                        aria-describedby="input-1-live-feedback"
                      />

                    </b-form-group>

                  </div>
                  <div class="hello">
                    <b-form-group :label="`${$t('PhoneNumber')}`">
                      <vue-phone-number-input
                        id="phone"
                        v-model="form.telephoneNumber"
                        default-country-code="XK"
                        :preferred-countries="['AL', 'CH', 'DE']"
                        @update="getFormattedNumber"
                      />
                    </b-form-group>
                    <b-form-group :label="`${$t('Instagram')}`">
                      <b-form-input
                        id="instagram"
                        v-model="form.instagram"
                        placeholder="e.g. @username"
                      />
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
            </b-tab>

            <b-tab

              :title="$t('BillingAddress')"
            >
              <template #title>
                <strong style="font-weight: 500; color: black">{{ $t("BillingAddress") }}</strong>
              </template>
              <div>
                <b-collapse
                  id="collapse-345"
                  visible
                >
                  <div class="hello">
                    <b-form-group :label="`${$t('Street')}`">
                      <b-form-input
                        id="street"
                        v-model="form.billingAddressInternalDto.street"
                        placeholder="e.g. Rexhep Mala"
                        aria-describedby="input-1-live-feedback"
                      />
                      <div v-if="hasAddressInput('billing') && !form.billingAddressInternalDto.street" class="validation-error">
                        {{ $t('This field is required') }}
                      </div>
                    </b-form-group>

                    <b-form-group :label="`${$t('HouseNumber')}`">
                      <b-form-input
                        id="houseNr"
                        v-model="form.billingAddressInternalDto.houseNumber"
                        type="text"
                        step="any"
                        min="0"
                        placeholder="e.g. 30"
                        aria-describedby="input-1-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-1-live-feedback"> {{
                        $t('This_is_a_required_field_and_must_contains_numbers')
                      }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="hello">
                    <b-form-group :label="`${$t('DoorNumber')}`">
                      <b-form-input
                        id="doorNr"
                        v-model="form.billingAddressInternalDto.doorNumber"
                        type="text"
                        placeholder="e.g. 50"
                        step="any"
                        min="0"
                        aria-describedby="input-1-live-feedback"
                      />
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                        $t('This_is_a_required_field_and_must_contains_numbers')
                      }}
                      </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group :label="`${$t('PostalCode')}`">
                      <b-form-input
                        id="postal"
                        v-model="form.billingAddressInternalDto.postalCode"
                        min="0"
                        placeholder="e.g. 10000"
                        aria-describedby="input-1-live-feedback"
                      />
                      <div v-if="hasAddressInput('billing') && !form.billingAddressInternalDto.postalCode" class="validation-error">
                        {{ $t('This field is required') }}
                      </div>
                    </b-form-group>
                  </div>
                  <div class="hello">
                    <b-form-group :label="`${$t('City')}`">
                      <b-form-input
                        id="city"
                        v-model="form.billingAddressInternalDto.city"
                        placeholder="e.g. Prishtinë"
                        aria-describedby="input-1-live-feedback"
                      />
                      <div v-if="hasAddressInput('billing') && !form.billingAddressInternalDto.city" class="validation-error">
                        {{ $t('This field is required') }}
                      </div>
                    </b-form-group>
                    <b-form-group :label="`${$t('Country')}`">
                      <b-form-input
                        id="country"
                        v-model="form.billingAddressInternalDto.country"
                        placeholder="e.g. Kosovë"
                        aria-describedby="input-1-live-feedback"
                      />
                      <div v-if="hasAddressInput('billing') && !form.billingAddressInternalDto.country" class="validation-error">
                        {{ $t('This field is required') }}
                      </div>
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
            </b-tab>

            <b-tab

              :title="$t('ShippingAddress')"
            >
              <template #title>
                <strong style="font-weight: 500; color: black">{{ $t("ShippingAddress") }}</strong>
              </template>
              <div>
                <b-collapse
                  id="collapse-345"
                  visible
                >
                  <div>
                    <div class="hello">
                      <b-form-group :label="`${$t('Street')}`">
                        <b-form-input
                          v-model="form.shippingAddressInternalDto.street"
                          :disabled="pickUpInStore"
                          placeholder="e.g. Rexhep Mala"
                          aria-describedby="input-1-live-feedback"
                        />
                        <div v-if="hasAddressInput('shipping') && !form.shippingAddressInternalDto.street" class="validation-error">
                          {{ $t('This field is required') }}
                        </div>
                      </b-form-group>

                      <b-form-group :label="`${$t('HouseNumber')}`">
                        <b-form-input
                          v-model="form.shippingAddressInternalDto.houseNumber"
                          :disabled="pickUpInStore"
                          placeholder="e.g. 30"
                          type="text"
                          step="any"
                          min="0"
                          aria-describedby="input-1-live-feedback"
                        />
                        <b-form-invalid-feedback id="input-1-live-feedback">{{
                          $t('This_is_a_required_field_and_must_contains_numbers')
                        }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                    <div class="hello">
                      <b-form-group :label="`${$t('DoorNumber')}`">
                        <b-form-input
                          v-model="form.shippingAddressInternalDto.doorNumber"
                          :disabled="pickUpInStore"
                          type="text"
                          placeholder="e.g. 50"
                          step="any"
                          min="0"
                          aria-describedby="input-1-live-feedback"
                        />
                        <b-form-invalid-feedback id="input-1-live-feedback">{{
                          $t('This_is_a_required_field_and_must_contains_numbers')
                        }}
                        </b-form-invalid-feedback>
                      </b-form-group>

                      <b-form-group :label="`${$t('PostalCode')}`">
                        <b-form-input
                          v-model="form.shippingAddressInternalDto.postalCode"
                          :disabled="pickUpInStore"
                          placeholder="e.g. 10000"
                          min="0"
                          aria-describedby="input-1-live-feedback"
                        />
                        <div v-if="hasAddressInput('shipping') && !form.shippingAddressInternalDto.postalCode" class="validation-error">
                          {{ $t('This field is required') }}
                        </div>
                      </b-form-group>
                    </div>
                    <div class="hello">
                      <b-form-group :label="`${$t('City')}`">
                        <b-form-input
                          v-model="form.shippingAddressInternalDto.city"
                          :disabled="pickUpInStore"
                          placeholder="e.g. Prishtinë"
                          aria-describedby="input-1-live-feedback"
                        />
                        <div v-if="hasAddressInput('shipping') && !form.shippingAddressInternalDto.city" class="validation-error">
                          {{ $t('This field is required') }}
                        </div>
                      </b-form-group>
                      <b-form-group :label="`${$t('Country')}`">
                        <b-form-input
                          v-model="form.shippingAddressInternalDto.country"
                          :disabled="pickUpInStore"
                          placeholder="e.g. Kosovë"
                          aria-describedby="input-1-live-feedback"
                        />
                        <div v-if="hasAddressInput('shipping') && !form.shippingAddressInternalDto.country" class="validation-error">
                          {{ $t('This field is required') }}
                        </div>
                      </b-form-group>
                    </div>
                    <span
                      class="duplicate-material"
                      @click="duplicateBillingAddress(), resetPickUpInStore()"
                    >
                      {{ $t('SameAsBillingAddress') }}
                    </span>
                  </div>
                </b-collapse>
              </div>
            </b-tab>

            <b-tab :title="$t('Measurements')">
              <template #title>
                <strong style="font-weight: 500; color: black">{{ $t("Measurements") }}</strong>
              </template>
              <div class="skica-container" style="padding-top: 15px;">
                <b-collapse
                  :id="`collapse`"
                  visible
                >
                  <div class="btn-con">
                    <button type="button" @click="showBody = !showBody">
                      {{ $t('FlipBody') }}
                    </button>
                  </div>
                  <div v-if="showBody" class="front-body">
                    <img src="../../../assets/images/front-body.svg" alt="">
                    <div class="toraks">
                      <b-form-input
                        v-model="form.bodyMeasurement.thorax"
                        :placeholder="$t('toraks')"
                        class="toraks1"
                      />
                    </div>
                    <div class="rrethiGjoksit">
                      <b-form-input
                        v-model="form.bodyMeasurement.aroundBust"
                        :placeholder="$t('rrethiGjoksit')"
                        class="rrethiGjoksit1"
                      />
                    </div>
                    <div class="rrethiNenGjoksit">
                      <b-form-input
                        v-model="form.bodyMeasurement.aroundUnderBust"
                        :placeholder="$t('rrethiNenGjoksit')"
                        class="rrethiNenGjoksit1"
                      />
                    </div>
                    <div class="beli">
                      <b-form-input
                        v-model="form.bodyMeasurement.waist"
                        :placeholder="$t('beli')"
                        class="beli1"
                      />
                    </div>
                    <div class="vithet">
                      <b-form-input
                        v-model="form.bodyMeasurement.aroundHips"
                        :placeholder="$t('RrethiVitheve')"
                        class="vithet1"
                      />
                    </div>
                    <div class="rrethiKembes">
                      <b-form-input
                        v-model="form.bodyMeasurement.aroundLeg"
                        :placeholder="$t('rrethiKembes')"
                        class="rrethiKembes1"
                      />
                    </div>
                    <div class="rrethiGjurit">
                      <b-form-input
                        v-model="form.bodyMeasurement.aroundKnee"
                        :placeholder="$t('rrethiGjurit')"
                        class="rrethiGjurit1"
                      />
                    </div>
                    <div class="zoguKembeve">
                      <b-form-input
                        v-model="form.bodyMeasurement.ankle"
                        :placeholder="$t('zoguKembeve')"
                        class="zoguKembeve1"
                      />
                    </div>
                    <div class="reniaGjoksit">
                      <b-form-input
                        v-model="form.bodyMeasurement.breastReduction"
                        :placeholder="$t('reniaGjoksit')"
                        class="reniaGjoksit1"
                      />
                    </div>
                    <div class="distancaGjoksit">
                      <b-form-input
                        v-model="form.bodyMeasurement.chestDistance"
                        :placeholder="$t('distancaGjoksit')"
                        class="distancaGjoksit1"
                      />
                    </div>
                    <div class="nderGjoks">
                      <b-form-input
                        v-model="form.bodyMeasurement.interBust"
                        :placeholder="$t('nderGjoks')"
                        class="nderGjoks1"
                      />
                    </div>
                    <div class="trupiPara">
                      <b-form-input
                        v-model="form.bodyMeasurement.frontBody"
                        :placeholder="$t('trupiPara')"
                        class="trupiPara1"
                      />
                    </div>
                    <div class="gjatesia1">
                      <b-form-input
                        v-model="form.bodyMeasurement.length1"
                        :placeholder="$t('gjatesia1')"
                        class="gjatesia11"
                      />
                    </div>
                    <div class="gjatesia2">
                      <b-form-input
                        v-model="form.bodyMeasurement.length2"
                        :placeholder="$t('gjatesia2')"
                        class="gjatesia21"
                      />
                    </div>
                    <div class="gjatesia3">
                      <b-form-input
                        v-model="form.bodyMeasurement.length3"
                        :placeholder="$t('gjatesia3')"
                        class="gjatesia31"
                      />
                    </div>
                    <div class="gjatesia4">
                      <b-form-input
                        v-model="form.bodyMeasurement.length4"
                        :placeholder="$t('gjatesia4')"
                        class="gjatesia41"
                      />
                    </div>
                  </div>
                  <div v-if="!showBody" class="back-body">
                    <img src="../../../assets/images/back-body.svg" alt="">
                    <div class="rrethiMenges">
                      <b-form-input
                        v-model="form.bodyMeasurement.aroundSleeve"
                        :placeholder="$t('rrethiMenges')"
                        class="rrethiMenges1"
                      />
                    </div>
                    <div class="brryli">
                      <b-form-input
                        v-model="form.bodyMeasurement.elbow"
                        :placeholder="$t('brryli')"
                        class="brryli1"
                      />
                    </div>
                    <div class="kyçi">
                      <b-form-input
                        v-model="form.bodyMeasurement.wrist"
                        :placeholder="$t('kyqi')"
                        class="kyçi1"
                      />
                    </div>
                    <div class="rrethiQafes">
                      <b-form-input
                        v-model="form.bodyMeasurement.aroundNeck"
                        :placeholder="$t('rrethiQafes')"
                        class="rrethiQafes1"
                      />
                    </div>
                    <div class="trupiPrapa">
                      <b-form-input
                        v-model="form.bodyMeasurement.backBody"
                        :placeholder="$t('trupiPrapa')"
                        class="trupiPrapa1"
                      />
                    </div>
                    <div class="supet">
                      <b-form-input
                        v-model="form.bodyMeasurement.shoulders"
                        :placeholder="$t('supet')"
                        class="supet1"
                      />
                    </div>
                    <div class="shpina">
                      <b-form-input
                        v-model="form.bodyMeasurement.back"
                        :placeholder="$t('shpina')"
                        class="shpina1"
                      />
                    </div>
                    <div class="reniaVitheve">
                      <b-form-input
                        v-model="form.bodyMeasurement.declineOfTheHips"
                        :placeholder="$t('reniaVitheve')"
                        class="reniaVitheve1"
                      />
                    </div>
                    <div class="gjatesiaMenges">
                      <b-form-input
                        v-model="form.bodyMeasurement.sleeveLength"
                        :placeholder="$t('gjatesiaMenges')"
                        class="gjatesiaMenges1"
                      />
                    </div>
                  </div>
                </b-collapse>
              </div>
            </b-tab>

              <b-tab :title="$t('Characteristics')">
                <template #title>
                  <strong style="font-weight: 500; color: black">{{ $t("Characteristics") }}</strong>
                </template>
                <div>
                  <b-collapse visible>
                    <div class="hello">
                      <b-form-group :label="$t('favoriteColor')">
                        <b-form-input
                          v-model="form.characteristicJsonRequestDto.favoriteColor"
                          :placeholder="$t('Color')"
                        />
                      </b-form-group>

                      <b-form-group :label="$t('favoriteDress')">
                        <b-form-input
                          v-model="form.characteristicJsonRequestDto.favoriteDress"
                          :placeholder="$t('Dress')"
                        />
                      </b-form-group>
                    </div>
                    <div>
                      <b-form-group :label="`${$t('generalDescription')}:`">
                        <b-form-textarea
                          v-model="form.characteristicJsonRequestDto.generalDescription"
                          :placeholder="$t('Notes')"
                          aria-describedby="input-1-live-feedback"
                        />
                      </b-form-group>
                    </div>
                  </b-collapse>
                </div>
              </b-tab>

            <b-tab :title="$t('Event')">
              <template #title>
                <strong style="font-weight: 500; color: black">{{ $t("Event") }}</strong>
              </template>
              <div>
                <b-collapse visible>
                  <div class="hello">
                    <b-form-group :label="$t('Type')">
                      <vue-select
                        v-model="form.eventJsonRequestDto.type"
                        :options="eventTypes"
                        :placeholder="$t('Select')"
                      />
                    </b-form-group>
                    <b-form-group :label="$t('Ocassion')">
                      <vue-select
                        v-model="form.eventJsonRequestDto.ocassion"
                        :options="occasionsOptions"
                        :placeholder="$t('Select')"
                      />
                    </b-form-group>
                  </div>
                  <div>
                    <b-form-group
                      id="input-group-4"
                      :label="`${$t('Notes')}:`"
                      label-for="input-4"
                    >
                      <b-form-textarea
                        id="input-4"
                        v-model="form.eventJsonRequestDto.notes"
                        :placeholder="$t('Notes')"
                        aria-describedby="input-1-live-feedback"
                      />
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
            </b-tab>

            </b-tabs>
        </section>
      </b-form>

      <div class="buttonsEverywhere">
        <b-button
          v-if="tabIndex == 5"
          type="button"
          variant="none"
          style="margin-top: 20px;background: #FF274F !important;"
          class="buttonSubmit"
          @click="onSubmit"
        >
          {{ $t('Submit') }}
        </b-button>
        <b-button
          v-else
          class="buttonSubmit"
          style="margin-top: 20px;background: #FF274F !important;"
          @click="tabIndex++"
        >
          {{ $t("Next") }}
        </b-button>
        <b-button
          type="reset"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; margin-top: 20px;background: white; color: black; border-color: white; font-weight: 400;"
          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import moment from 'moment'

export default {
  components: { DatePicker },
  mixins: [validationMixin],

  props: {
    campaignId: {
      type: String,
      required: true,
      validator: (value) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value),
    },
  },

  data() {
    return {
      tabIndex: 0,
      lang: this.$i18n.locale,
      selectedDate: null,
      showBody: true,
      pickUpInStore: false,
      isSubmitting: false,
      salutation: ['Mr', 'Ms', 'Mrs'],
      genderOptions: [
        { text: 'Male', value: 'Male' },
        { text: 'Female', value: 'Female' },
      ],
      eventTypes: ['Phone', 'Email', 'Social Media', 'Fashion Week', 'Workshop', 'Black Friday', 'Other'],
      occasionsOptions: [],
      form: this.getEmptyForm(),
    }
  },

  validations: {
    form: {
      firstName: { required, minLength: minLength(3) },
      lastname: { required, minLength: minLength(3) },
    },
  },

  computed: {
    ...mapGetters(['getUsersByRole', 'getCampaignOccasions']),
  },

  mounted() {
    this.loadOccasions()
  },

  methods: {
    ...mapActions(['addCampaignLead']),

    // Form helpers
    getEmptyForm() {
      return {
        salutation: null,
        firstName: null,
        lastname: null,
        email: null,
        gender: null,
        telephoneNumber: null,
        countryCode: null,
        dateOfBirth: null,
        instagram: null,
        billingAddressInternalDto: {
          street: null, houseNumber: null, doorNumber: null,
          postalCode: null, city: null, country: null,
        },
        shippingAddressInternalDto: {
          street: null, houseNumber: null, doorNumber: null,
          postalCode: null, city: null, country: null,
        },
        bodyMeasurement: {
          thorax: null, aroundBust: null, aroundUnderBust: null, waist: null,
          aroundHips: null, aroundLeg: null, aroundKnee: null, ankle: null,
          breastReduction: null, interBust: null, frontBody: null, chestDistance: null,
          length1: null, length2: null, length3: null, length4: null,
          aroundSleeve: null, elbow: null, wrist: null, aroundNeck: null,
          backBody: null, shoulders: null, back: null, declineOfTheHips: null, sleeveLength: null,
        },
        eventJsonRequestDto: { type: null, ocassion: null, notes: null },
        characteristicJsonRequestDto: { favoriteColor: null, favoriteDress: null, generalDescription: null },
      }
    },

    validateState(fieldName) {
      const { $dirty, $error } = this.$v.form[fieldName]
      return $dirty ? !$error : null
    },

    validateAddressFields(address) {
      if (!address) return true;
      const { street, postalCode, city, country } = address;
      const requiredFields = [street, postalCode, city, country];
      const filledFields = requiredFields.filter(field => field !== null && field !== '');
      
      // If no fields are filled, address is valid (completely empty)
      // If some fields are filled, all 4 required fields must be filled
      if (filledFields.length === 0) return true;
      return filledFields.length === 4;
    },

    hasAddressInput(addressType) {
      const address = addressType === 'billing' 
        ? this.form.billingAddressInternalDto 
        : this.form.shippingAddressInternalDto;
      
      if (!address) return false;
      const { street, postalCode, city, country } = address;
      const requiredFields = [street, postalCode, city, country];
      return requiredFields.some(field => field !== null && field !== '');
    },

    getFormattedNumber(payload) {
      this.form.telephoneNumber = payload.nationalNumber
      this.form.countryCode = payload.countryCode
    },

    duplicateBillingAddress() {
      this.form.shippingAddressInternalDto = { ...this.form.billingAddressInternalDto }
    },

    resetPickUpInStore() {
      this.pickUpInStore = false
    },

    openModal() {
      this.$refs.modal.show()
    },

    loadOccasions() {
      if (this.getCampaignOccasions?.length) {
        this.occasionsOptions = this.getCampaignOccasions.map(o => ({
          label: o.name || o.lovCampaignOccasionName || o.value || o.displayName,
          value: o.lovCampaignOccasionId || o.id || o.value,
        }))
      } else {
        this.$store.dispatch('fetchCampaignOccasions')
          .then(res => {
            if (Array.isArray(res)) {
              this.occasionsOptions = res.map(o => ({
                label: o.name || o.lovCampaignOccasionName || o.value || o.displayName,
                value: o.lovCampaignOccasionId || o.id || o.value,
              }))
            }
          })
          .catch(() => {})
      }
    },

hasValidMeasurements(measurements) {
  if (!measurements) return false;
  return Object.values(measurements).some(val => val !== null && val !== '');
},

buildPayload() {
  const dateOfBirthPayload = this.selectedDate
    ? moment(this.selectedDate, 'DD-MM-YYYY').toISOString()
    : null;

  return {
    campaignId: this.campaignId,
    clientClientRequestDto: {
      salutation: this.form.salutation,
      firstName: this.form.firstName,
      lastname: this.form.lastname,
      email: this.form.email,
      gender: this.form.gender,
      telephoneNumber: this.form.telephoneNumber,
      countryCode: this.form.countryCode,
      dateOfBirth: dateOfBirthPayload,
      instagram: this.form.instagram,

      billingAddressInternalDto: this.hasAddress(this.form.billingAddressInternalDto) 
        ? { ...this.form.billingAddressInternalDto } 
        : null,

      shippingAddressInternalDto: this.hasAddress(this.form.shippingAddressInternalDto) 
        ? { ...this.form.shippingAddressInternalDto } 
        : null,

      BodyMeasurementDto: this.form.bodyMeasurement, 
      eventCreateRequestDto: {
        eventJsonRequestDto: {
          type: this.form.eventJsonRequestDto.type,
          ocassion: this.form.eventJsonRequestDto.ocassion?.value || this.form.eventJsonRequestDto.ocassion,
          notes: this.form.eventJsonRequestDto.notes
        }
      },
      characteristicJsonRequestDto: this.hasCharacteristics(this.form.characteristicJsonRequestDto) ? { ...this.form.characteristicJsonRequestDto } : null,
    },
  };
},

hasCharacteristics(chars) {
  return chars && Object.values(chars).some(val => val !== null && val !== '');
},

hasAddress(addr) {
  return addr && Object.values(addr).some(val => val !== null && val !== '');
},

    async onSubmit() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) return

      if (!this.validateAddressFields(this.form.billingAddressInternalDto)) return
      if (!this.validateAddressFields(this.form.shippingAddressInternalDto)) return

      this.isSubmitting = true

      try {
        const payload = this.buildPayload()
        await this.addCampaignLead({ object: payload })

        this.$refs.modal.hide()
        this.resetForm()
        this.$emit('leadAdded')
      } catch (err) {
        console.error('Add campaign lead failed:', err)
      } finally {
        this.isSubmitting = false
      }
    },

    onCancel() {
      this.$refs.modal.hide()
      this.resetForm()
    },

    // characteristics are edited directly on `form.characteristics`

    resetForm() {
      this.tabIndex = 0
      this.selectedDate = null
      this.showBody = true
      this.form = this.getEmptyForm()
      setTimeout(() => this.$v.$reset(), 0)
    },
  },
}
</script>


<style lang="scss" scoped>

fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
    width: 49%;
}

.hello{
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

form {
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.headline {
  padding: 10px 10px;
  background-color: white;
  color: black;
  font-weight: bold;
  border-radius: 8px;
}

.custom-modal__wrapper {
  display: flex;
  justify-content: space-between;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 10px 0px;

  >div {
    flex: 1;
    margin: 0px 15px;
  }
}

.flex-form {
  display: flex;
  flex-direction: column;
}

.fixed-height-modal {
  height: 100%;
  overflow-y: auto;
  padding-right: 1rem;
}

.customDress-container {
  border: 3px solid lightgray;
  border-radius: 10px;
  padding: 15px;
  margin-top: 20px;
}

.customDress-container:last-child {
  margin-bottom: 20px;
}

.inside-actions {
  margin-left: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  box-shadow: none;
  padding: 2px 4px;
  border-radius: 7px;
}

.inside-actions:hover {
  background-color: #242F6E;
  color: #fff;
}

.f {
  border-color: red !important;
}

.front-body {
  position: relative;
  display: flex;
  justify-content: center;
  gap: 50px;
  padding-bottom: 20px;

  img {
    width: 100%;
  }
  .betweenCol{
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
  .input{
    max-width: 100%;
    height: 51px;
    display: flex;
    flex-direction: column;
    gap: 0px;
  }
  .toraks {
    display: flex;
    position: absolute;
    top: 106px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .rrethiGjoksit {
    display: flex;
    position: absolute;
    top: 135px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .rrethiNenGjoksit {
    display: flex;
    position: absolute;
    top: 165px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .beli {
    display: flex;
    position: absolute;
    top: 200px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .vithet {
    display: flex;
    position: absolute;
    top: 263px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .rrethiKembes {
    display: flex;
    position: absolute;
    bottom: 222px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .rrethiGjurit {
    display: flex;
    position: absolute;
    bottom: 148px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .zoguKembeve {
    display: flex;
    position: absolute;
    bottom: 38px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .reniaGjoksit {
    display: flex;
    position: absolute;
    top: 85px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .nderGjoks {
    display: flex;
    position: absolute;
    top: 158px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .trupiPara {
    display: flex;
    position: absolute;
    top: 200px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .distancaGjoksit {
    display: flex;
    position: absolute;
    top: 128px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .gjatesia1 {
    display: flex;
    position: absolute;
    bottom: 222px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .gjatesia2 {
    display: flex;
    position: absolute;
    bottom: 127px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .gjatesia3 {
    display: flex;
    position: absolute;
    bottom: 68px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .gjatesia4 {
    display: flex;
    position: absolute;
    bottom: 8px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
}

.btn-con {
  display: flex;

  button {
    border: none;
    background: #FF274F;
    color: white;
    border-radius: 0.25rem;
    padding: 3px 12px;
  }
}

.back-body {
  position: relative;

  img {
    width: 100%;
  }

  .rrethiMenges {
    display: flex;
    position: absolute;
    top: 126px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .brryli {
    display: flex;
    position: absolute;
    top: 156px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .kyçi {
    display: flex;
    position: absolute;
    top: 192px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .rrethiQafes {
    display: flex;
    position: absolute;
    top: 60px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .trupiPrapa {
    display: flex;
    position: absolute;
    top: 202px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .supet {
    display: flex;
    position: absolute;
    top: 97px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .shpina {
    display: flex;
    position: absolute;
    top: 135px;
    left: 100px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .reniaVitheve {
    display: flex;
    position: absolute;
    bottom: 253px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }

  .gjatesiaMenges {
    display: flex;
    position: absolute;
    top: 95px;
    right: 110px;
    max-width: 180px;
    width: 100%;
    height: 25px;
  }
}

@media only screen and (max-width: 1200px) {
  .front-body {
    position: relative;

    .toraks {
      top: 65px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .rrethiGjoksit {
      position: absolute;
      top: 95px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .rrethiNenGjoksit {
      position: absolute;
      top: 125px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .beli {
      position: absolute;
      top: 155px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .vithet {
      position: absolute;
      top: 249px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .rrethiKembes {
      position: absolute;
      bottom: 65px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .rrethiGjurit {
      position: absolute;
      bottom: 35px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .zoguKembeve {
      position: absolute;
      bottom: 5px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .reniaGjoksit {
      position: absolute;
      top: 65px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .nderGjoks {
      position: absolute;
      top: 125px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .trupiPara {
      position: absolute;
      top: 155px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .distancaGjoksit {
      position: absolute;
      top: 95px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .gjatesia1 {
      position: absolute;
      bottom: 95px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .gjatesia2 {
      position: absolute;
      bottom: 65px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .gjatesia3 {
      position: absolute;
      bottom: 35px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .gjatesia4 {
      position: absolute;
      bottom: 5px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }
  }

  .btn-con {
    display: flex;

    button {
      border: none;
      background-color: #6c757d;
      color: white;
      border-radius: 0.25rem;
      padding: 3px 12px;
    }
  }

  .back-body {
    position: relative;

    img {
      width: 100%;
    }

    .rrethiMenges {
      position: absolute;
      top: 126px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .brryli {
      position: absolute;
      top: 156px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .kyçi {
      position: absolute;
      top: 192px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .rrethiQafes {
      position: absolute;
      top: 70px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .trupiPrapa {
      position: absolute;
      top: 215px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .supet {
      position: absolute;
      top: 97px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .shpina {
      position: absolute;
      top: 70px;
      left: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .reniaVitheve {
      position: absolute;
      bottom: 100px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }

    .gjatesiaMenges {
      position: absolute;
      top: 98px;
      right: 1px;
      max-width: 150px;
      width: 100%;
      height: 25px;
    }
  }
}

input[type="radio"]:checked:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -3px;
  left: -1px;
  position: relative;
  background-color: #0A2F51;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}

.duplicate-material {
  color: #FF274F;
  cursor: pointer;
  font-weight: 500;
  margin-top: 10px;
  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
}

.validation-error {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}

.buttonsEverywhere {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 20px;
}

.buttonSubmit {
  background: #FF274F;
  flex: 1;
  height: 37px;
  color: white;
  border: none;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
}

.buttonCancel {
  background: white;
  color: black;
  border: 1px solid #dcdfe6;
  font-weight: 400;
  flex: 1;
  height: 37px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}
.modal-loader {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>